import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck, ViewEncapsulation } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import * as encoding from 'encoding-japanese';
import { ShipService } from '../../../service/ship/ship.service';
import { ShipInvoiceService } from '../../../service/ship-invoice/ship-invoice.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { getCreateFormRequest } from '../../../util/util';
import { CreateFormService } from '../../../service/create-form/create-form.service';

declare const cwebclient:any;

@Component({
  selector: 'app-root',
  templateUrl: 'wa3010.component.html',
  styleUrls: ['wa3010.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Wa3010Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA3010:出荷指示照会';
  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData = [];
  public checkbox: boolean;
  public ownerId: number;
  public ownerResult: any;
  public ships: any;
  public shipnoCd: any;
  public ordernoCd: any;
  public carrierTx: any;
  public delirouteTx: any;
  public dtnameTx: any;
  public shiphId: number;
  public config = config;
  // 印刷設定
  // 納品書
  private printagentCd = '';
  public working = false;
  private isShowSendLoading = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public doPickBreak: boolean;
  public doMultiPick: boolean;
  public backgroundColor: string;
  public updprogramCd = 'wa3010';
  private errorInfo = '';
  @ViewChild('gridView')
  gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private isEnableClearFilterButton = false;

  private isShowGridNoDataOverlay = false;

  /** pagination */
  private totalCount = 0;
  private selectedCount = 0;
  private paginationGetRowCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private tabIndex = 0;
  private isTab1CheckboxChecked = false;
  private isTab2CheckboxChecked = false;
  private isForShipEndCheckBoxChecked = false;
  private isFilterExcludeChecked = false;
  private openwindow = '';
  private isEnableRightAreaButtons = false;
  private isEnableDropActions = false;
  private originalRowData: any[];
  private isShowActionMenu = false;
  private isBlockActionMenu = false;
  public overlay: number;
  private overlaydspnone = true;
  private tab1BadgeNumber = 0;
  private isShowStockOutOverlay = false;
  private disabled = true;
  private delete = false;
  private completeShipsConfirm = false;
  private cancelConfirm = false;
  private isShow3013 = false;
  private loading = false;
  private isOwnerSearchNone = false;
  private isShipComplete = false;
  private isOwnerLinked = false;
  public isAbleToMultiPick = false;
  private shipDate = null;

  constructor(
    private router: Router,
    private shipService: ShipService,
    private shipInvoiceService: ShipInvoiceService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private createFormService: CreateFormService
  ) {
    this.cardHeight = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.working = true;
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -111;

    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    const loginResult = sessionStorage.getItem('loginResult');
    if (loginResult !== null) {
      const user = JSON.parse(loginResult).user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
      const optionUsage = JSON.parse(loginResult).optionUsage;
      this.isAbleToMultiPick = optionUsage.MULTI_PICK;
      // SWMS-3285 ピックブレイク(無料)とマルチピック(有料)を分離。
      // マルチピック要否は MULTI_PICK オプションで決定(未設定はfalse)。
      this.doMultiPick = optionUsage.MULTI_PICK == null ? false : optionUsage.MULTI_PICK;
      // ピックブレイク要否は PICK_BREAK オプション。未設定(null/undefined)の場合はマルチピックに追従する
      // (マルチピック契約企業はブレイク必須のため。PICK_BREAK 未投入でも引当継続できる)。
      this.doPickBreak = optionUsage.PICK_BREAK == null ? this.doMultiPick : optionUsage.PICK_BREAK;
    }

    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3010_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.el.nativeElement.querySelector('div.ag-spread .ag-pinned-left-header .ag-header-cell:nth-child(2) .ag-floating-filter-body').style.display = 'block';
        this.gridHelper.el.nativeElement.querySelector('div.ag-spread .ag-pinned-left-header .ag-header-cell:nth-child(2) .ag-floating-filter-button').style.display = 'block';
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        if (this.gridOptions.api.isAnyFilterPresent()) {
          this.tab1BadgeNumber = 0;
          this.gridOptions.api.forEachNodeAfterFilter(rowNode => {
            if (rowNode.data.dterrorFl == 1 || rowNode.data.deliassorterrorFl == 1) this.tab1BadgeNumber++;
          });
          this.isShowGridNoDataOverlay = this.gridHelper.isShowGridNoDataOverlay;
        }

        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        if (this.gridOptions.api.isAnyFilterPresent()) {
          this.tab1BadgeNumber = 0;
          this.gridOptions.api.forEachNodeAfterFilter(rowNode => {
            if (rowNode.data.dterrorFl == 1 || rowNode.data.deliassorterrorFl == 1) this.tab1BadgeNumber++;
          });
        }
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        this.isEnableRightAreaButtons = this.selectedCount > 0;

        this.isEnableDropActions = this.isEnableRightAreaButtons;
        this.isShipComplete = false;

        const isShipMentPart1 = false;
        let isConstainsNotComplete = false;
        let isDiff = false;
        this.gridOptions.api.forEachNode(node => {
          if (node['selected'] == true) {
            if (this.tabIndex == 1) {
              this.isEnableDropActions = node.data.stshipTx === 'キャンセル';
              if (node.data.stshipTx === '引当完了')
                this.isShipComplete = true;
              else
                isConstainsNotComplete = true;
            }
          }
        });
        isDiff = this.isShipComplete && isConstainsNotComplete;
        this.isShipComplete = this.isShipComplete && !isConstainsNotComplete;
        this.isEnableDropActions = this.isEnableDropActions ? (this.tabIndex == 1 ? (!isDiff) : true) : this.isShipComplete;
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        if (this.tabIndex === 0) {
          this.gridOptions.api.paginationSetPageSize(this.totalCount);
        }
        this.maxPage = this.gridOptions.api.paginationGetTotalPages();
        this.currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        field: 'checkbox',
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressFilter: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        checkboxSelection: true,
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '出荷番号',
        field: 'shipnoCd',
        width: this.getColumnWidth('shiphId', this.isOwnerLinked ? 150 : 220),
        sort: 'desc',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat'],
        pinned: 'left',
        filter: 'text',
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '詳細',
          itemFieldBeforeButton: 'shipnoCd',
          badge: {
            getClassName: function (data) {
              if (data.dterrorFl == 1 || data.deliassorterrorFl == 1) return 'exc_red';
              else if (data.shipreserveFl == 1) return 'exc_blue';
              else return null;
            },
            text: '!'
          },
          onClick: this.oGridDetailButtonClick.bind(this)
        }
      },

      {
        field: 'col1Scroll:155',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stshipTx == '欠品') {
            return { backgroundColor: 'rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.2)' };
          } else if (params.data.stshipTx == '未引当') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: 'rgba(235,153,175,0.2)' };
          } else if (params.data.stshipTx == '引当完了') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.stshipTx == 'キャンセル') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '出荷ステータス',
        field: 'stshipTx',
        width: this.getColumnWidth('stshipTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '欠品') {
            return { backgroundColor: 'rgba(255,255,255,0.2)', color: 'rgba(217,59,59,1)' };
          } else if (params.value == '未引当') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '引当完了') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == 'キャンセル') {
            return { backgroundColor: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },

      {
        headerName: '受注番号',
        field: 'ordernoCd',
        width: this.getColumnWidth('ordernoCd', 110),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '出荷優先順位',
        field: 'priorityNr',
        width: this.getColumnWidth('priorityNr', 110),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '出荷指示日',
        headerTooltip: '出荷指示日',
        field: 'shipDt',
        width: this.getColumnWidth('shipDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送キャリア名',
        headerTooltip: '配送キャリア名',
        field: 'carrierTx',
        width: this.getColumnWidth('carrierTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先エラー',
        headerTooltip: '届先エラー',
        field: 'dterrorTx',
        width: this.getColumnWidth('dterrorTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先コード',
        headerTooltip: '届先コード',
        field: 'dtaddressCd',
        width: this.getColumnWidth('dtaddressCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先名',
        headerTooltip: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先郵便番号',
        headerTooltip: '届先郵便番号',
        field: 'dtpostalCd',
        width: this.getColumnWidth('dtpostalCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先住所1',
        headerTooltip: '届先住所1',
        field: 'dtaddress1Tx',
        width: this.getColumnWidth('dtaddress1Tx', 300),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先住所2',
        headerTooltip: '届先住所2',
        field: 'dtaddress2Tx',
        width: this.getColumnWidth('dtaddress2Tx', 300),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '届先電話番号',
        headerTooltip: '届先電話番号',
        field: 'dttelTx',
        width: this.getColumnWidth('dttelTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '依頼主郵便番号',
        headerTooltip: '依頼主郵便番号',
        field: 'rqpostalCd',
        width: this.getColumnWidth('rqpostalCd', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '依頼主住所1',
        headerTooltip: '依頼主住所1',
        field: 'rqaddress1Tx',
        width: this.getColumnWidth('rqaddress1Tx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '依頼主住所2',
        headerTooltip: '依頼主住所2',
        field: 'rqaddress2Tx',
        width: this.getColumnWidth('rqaddress2Tx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '依頼主住所3',
        headerTooltip: '依頼主住所3',
        field: 'rqaddress3Tx',
        width: this.getColumnWidth('rqaddress3Tx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '依頼主名',
        headerTooltip: '依頼主名',
        field: 'rqnameTx',
        width: this.getColumnWidth('rqnameTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '代行出荷',
        headerTooltip: '代行出荷',
        field: 'proxyshipTx',
        width: this.getColumnWidth('proxyshipTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '配送区分名',
        headerTooltip: '配送区分名',
        field: 'delitypeshortTx',
        width: this.getColumnWidth('delitypeshortTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '営業店止め',
        headerTooltip: '営業店止め',
        field: 'shiptodepoTx',
        width: this.getColumnWidth('shiptodepoTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '着荷指定日',
        headerTooltip: '着荷指定日',
        field: 'delidateTx',
        width: this.getColumnWidth('delidateTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '着荷指定時間帯',
        headerTooltip: '着荷指定時間帯',
        field: 'delitimeTx',
        width: this.getColumnWidth('delitimeTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '着荷指定時刻',
        headerTooltip: '着荷指定時刻',
        field: 'justdelitimeTx',
        width: this.getColumnWidth('justdelitimeTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '代引金額',
        headerTooltip: '代引金額',
        field: 'codpriceNr',
        width: this.getColumnWidth('codpriceNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '代引税額',
        headerTooltip: '代引税額',
        field: 'codtaxNr',
        width: this.getColumnWidth('codtaxNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '出荷備考',
        headerTooltip: '出荷備考',
        field: 'memoTx',
        width: this.getColumnWidth('memoTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '引当日時',
        headerTooltip: '引当日時',
        field: 'applyDt',
        width: this.getColumnWidth('applyDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当ユーザ名',
        headerTooltip: '引当ユーザ名',
        field: 'applyuserTx',
        width: this.getColumnWidth('applyuserTx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '配送データダウンロード日時',
        headerTooltip: '配送データダウンロード日時',
        field: 'downloadDt',
        width: this.getColumnWidth('downloadDt', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '納品書区分名',
        headerTooltip: '納品書区分名',
        field: 'typeshipinvoiceTx',
        width: this.getColumnWidth('typeshipinvoiceTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '納品書番号',
        headerTooltip: '納品書番号',
        field: 'invoicenoTx',
        width: this.getColumnWidth('invoicenoTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '出荷完了日時',
        headerTooltip: '出荷完了日時',
        field: 'shipendDt',
        width: this.getColumnWidth('shipendDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '出荷完了ユーザ名',
        headerTooltip: '出荷完了ユーザ名',
        field: 'shipenduserTx',
        width: this.getColumnWidth('shipenduserTx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '出荷保留',
        headerTooltip: '出荷保留',
        field: 'shipreserveTx',
        width: this.getColumnWidth('shipreserveTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '配送会社向け出荷実績送信日時',
        headerTooltip: '配送会社向け出荷実績送信日時',
        field: 'senddeliDt',
        width: this.getColumnWidth('senddeliDt', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '仕分コードエラー',
        headerTooltip: '仕分コードエラー',
        field: 'deliassorterrorTx',
        width: this.getColumnWidth('deliassorterrorTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '送信対象',
        headerTooltip: '送信対象',
        field: 'needsendTx',
        width: this.getColumnWidth('needsendTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '送信日時',
        headerTooltip: '送信日時',
        field: 'sendDt',
        width: this.getColumnWidth('sendDt', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票A欄',
        field: 'invaTx',
        width: this.getColumnWidth('invaTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票B欄',
        field: 'invbTx',
        width: this.getColumnWidth('invbTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票C欄',
        field: 'invcTx',
        width: this.getColumnWidth('invcTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票D欄',
        field: 'invdTx',
        width: this.getColumnWidth('invdTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票E欄',
        field: 'inveTx',
        width: this.getColumnWidth('inveTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票F欄',
        field: 'invfTx',
        width: this.getColumnWidth('invfTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票G欄',
        field: 'invgTx',
        width: this.getColumnWidth('invgTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票H欄',
        field: 'invhTx',
        width: this.getColumnWidth('invhTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票I欄',
        field: 'inviTx',
        width: this.getColumnWidth('inviTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票J欄',
        field: 'invjTx',
        width: this.getColumnWidth('invjTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票K欄',
        field: 'invkTx',
        width: this.getColumnWidth('invkTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票L欄',
        field: 'invlTx',
        width: this.getColumnWidth('invlTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票社名',
        field: 'invcompanyTx',
        width: this.getColumnWidth('invcompanyTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票店名',
        field: 'invstoreTx',
        width: this.getColumnWidth('invstoreTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票社・店コード',
        field: 'invstoreCd',
        width: this.getColumnWidth('invstoreCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票分類コード',
        field: 'invcategoryCd',
        width: this.getColumnWidth('invcategoryCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票区分',
        field: 'invtypeTx',
        width: this.getColumnWidth('invtypeTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票伝票番号',
        field: 'invnoTx',
        width: this.getColumnWidth('invnoTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票取引先コード',
        field: 'invsupplierCd',
        width: this.getColumnWidth('invsupplierCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票取引先名',
        field: 'invsupplierTx',
        width: this.getColumnWidth('invsupplierTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '伝票発注日',
        field: 'invorderdateTx',
        width: this.getColumnWidth('invorderdateTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票納品日',
        field: 'invdelidateTx',
        width: this.getColumnWidth('invdelidateTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '伝票便',
        field: 'invdelinoTx',
        width: this.getColumnWidth('invdelinoTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '更新日時',
        headerTooltip: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        headerTooltip: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '登録日時',
        headerTooltip: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        headerTooltip: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 180),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        field: 'ownerId',
        hide: true
      }
    ];
    this.gridOptions.excelStyles = [
      {
        //Text
        id: 'textFormat',
        dataType: 'string'
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    //SessionStorageから荷主Idを取得
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    // 印刷設定取得
    if (localStorage.getItem(`printagentCd`) !== null) {
      this.printagentCd = localStorage.getItem(`printagentCd`);
    }
    this.working = false;
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3010_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    //画面初期表示時はセッションクリア
    sessionStorage.removeItem('wa3010_filterModel');
    setTimeout(() => {
      if (this.headerComponent.isLogin === true) {
        this.onSubmit();
      }
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onView(event) {
    sessionStorage.setItem('wa3010_shiphId', event.data.shiphId);
    this.router.navigate(['wa3020']);
    //    window.open('/wa3020', 'wa3020');
  }

  onlynotapplied() {
    this.onSubmit();
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  onFilterClear() {
    //セッションからも削除
    sessionStorage.removeItem('wa3010_filterModel');
    //console.log('sessionからフィルタをクリアしました');    
    this.gridOptions.api.setFilterModel(null);
  }

  onFilterClearAndSubmit() {
    this.gridOptions.api.setFilterModel(null);
    //セッションからも削除
    sessionStorage.removeItem('wa3010_filterModel');  
    this.filterGrid();
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    const params: URLSearchParams = new URLSearchParams();
    this.selectedCount = 0;
    if (this.ownerId !== undefined) {
      params.set('ownerId', this.ownerId.toString());
    }
    if (this.checkbox) {
      params.set('notapplyFl', '1');
    }

    if (this.isForShipEndCheckBoxChecked) {
      params.set('forShipEnd', '1');
    }

    params.set('tabIndex', this.tabIndex.toString());

    this.shipService
      .get(params)
      .then(outputJson => {
        this.rowData = [];
        this.originalRowData = outputJson.ships;
        this.ships = outputJson.ships;
        setTimeout(() => {
          this.filterGrid();
          this.gridOptions.api.hideOverlay();
          this.working = false;
        }, 300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  checkShort() {
    this.errorInfo = '';
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.disabled = true;
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      // this.errorInfo = '対象を選択して下さい';
      this.disabled = false;
      return;
    }
    let ownerId: number;
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      if (i === 0) {
        ownerId = data['ownerId'];
      } else {
        if (ownerId !== data['ownerId']) {
          this.errorInfo = '複数荷主の出荷指示を一度に欠品チェックすることはできません。';
          this.disabled = false;
          return;
        }
      }
      const jsonUnit: object = {
        shiphId: data['shiphId']
      };
      selectItems.push(jsonUnit);
    }

    sessionStorage.setItem('wa3010-checkShort-selectItems', JSON.stringify(selectItems));
    //現時点のフィルタを保持
    this.saveFilterState();
    this.shipService
      .checkShort(ownerId, selectItems, 'wa3010')
      .then(outputJson => {
        if (outputJson.shorts.length > 0) {
          sessionStorage.setItem('shorts', JSON.stringify(outputJson.shorts));
          sessionStorage.setItem('wa3010-checkShort-ownerId', String(ownerId));
          this.openwindow = JSON.stringify(outputJson.shorts);
          this.isShow3013 = true;
          this.errorInfo = '';
          this.disabled = false;
          this.working = false;
        } else {
          this.working = false;
          sessionStorage.setItem('SuccessInfoMessage', '商品単位の欠品はありません');
        }
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShow3013 = false;
        this.disabled = false;
        this.working = false;
      });
  }

  apply() {
    let ownerId: number;
    this.errorInfo = '';
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      if (i === 0) {
        ownerId = data['ownerId'];
      }
      const jsonUnit: object = {
        shiphId: data['shiphId']
      };
      selectItems.push(jsonUnit);
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipService
      .apply(ownerId, selectItems, this.doPickBreak, this.doMultiPick, 'wa3010')
      .then(outputJson => {
        this.working = false;
        sessionStorage.setItem('SuccessInfoMessage', '出荷引当を受付しました。状況と結果は出荷引当ログ画面で確認してください。');
        this.close2();
        //現時点のフィルタを保持
        this.saveFilterState();
        this.onSubmit();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        //エラーメッセージが一覧の再取得で消えてしまうため、再取得しないclose1を使用する
        this.close1();
      });
  }

  updDeli() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    //現時点のフィルタを保持
    this.saveFilterState();
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('rowShips', JSON.stringify(this.rowData[selectedIndex]));
    sessionStorage.removeItem('dtaddressSelected');
    sessionStorage.removeItem('rowDtaddress');
    this.router.navigate(['wa3011']);
  }

  del() {
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.delete = false;
      this.working = false;
      return;
    }
    //SWMS-1175
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const shipreserveTx = data['shipreserveTx'];
      if (shipreserveTx === '出荷保留'){
        this.errorInfo = '出荷保留中の指示は削除できません。';
        this.delete = false;
        this.working = false;
        return;
      }
    }
    const selectedIndex: number[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      selectedIndex.push(data['shiphId']);
    }

    this.shipService
      .del(selectedIndex)
      .then(outputJson => {
        this.delete = false;
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '削除に設定しました。');
      })
      .catch(error => {
        this.delete = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  allExport() {
    this.gridOptions.api.exportDataAsCsv(this.gridApi.columnApi.getAllColumns());
  }

  // 出荷引当取消
  cancelapply() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;

      const jsonUnit: object = {
        shiphId: data['shiphId'],
        ownerId: data['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    //現時点のフィルタを保持
    this.saveFilterState();
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.shipService
      .cancelapply(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.isShowSendLoading = false;
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '出荷引当を取消しました。');
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 出荷保留
  reserve() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        shiphId: data['shiphId'],
        ownerId: data['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    console.log(selectItems);
    //現時点のフィルタを保持
    this.saveFilterState();
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipService
      .reserve(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '出荷保留に設定しました。');
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 出荷保留取消
  resetreserve() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        shiphId: data['shiphId'],
        ownerId: data['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    console.log(selectItems);
    //現時点のフィルタを保持
    this.saveFilterState();
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipService
      .resetreserve(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '保留取消に設定しました。');
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 出荷キャンセル
  cancel() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    //SWMS-1175
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const shipreserveTx = data['shipreserveTx'];
      if (shipreserveTx === '出荷保留'){
        this.errorInfo = '出荷保留中の指示はキャンセルできません。';
        return;
      }
    }

    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        shiphId: data['shiphId'],
        ownerId: data['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    //現時点のフィルタを保持
    this.saveFilterState();
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipService
      .cancel(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '出荷キャンセルに設定しました。');
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 出荷キャンセル取消
  resetcancel() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const jsonUnit: object = {
        shiphId: data['shiphId'],
        ownerId: data['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    //現時点のフィルタを保持
    this.saveFilterState();
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipService
      .resetcancel(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '出荷キャンセル取消に設定しました。');
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 出荷完了（確認ダイアログ表示）
  confirmCompleteShips() {
      this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    if (this.working) return;
    this.completeShipsConfirm = true;
  }

  // 出荷完了（実行）
  completeShips() {
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;

      const jsonUnit: object = {
        shiphId: data['shiphId']
      };

      selectItems.push(jsonUnit);
    }

    if (selectItems.length === 0) {
      this.errorInfo = '出荷完了可能な対象を選択して下さい';
      return;
    }

    //現時点のフィルタを保持
    this.saveFilterState();
    //ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.shipService
      .completeByShiphIdList(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.isShowSendLoading = false;

        if (outputJson.result) {
          sessionStorage.setItem('SuccessInfoMessage', '出荷が完了しました');
          this.working = false;
          this.onSubmit();
        } else {
          this.working = false;
          this.errorInfo = '出荷完了できませんでした。';
        }
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  // 納品書出力
  printInvoice() {

    const selectedNodes: object[] = this.gridOptions.api.getSelectedNodes();

    this.errorInfo = '';
    if (selectedNodes.length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }


    const selectedShiphIdSet: Set<number> = new Set<number>();

    for (let i = 0; i < selectedNodes.length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      const data = selectedNodes[i]['data'];
      if (data['typeshipinvoiceCd'] !== 'RD0000') {
        selectedShiphIdSet.add(data['shiphId']);
      }
    }
    if (selectedShiphIdSet.size === 0) {
      this.errorInfo = '納品書出力可能な対象を選択して下さい';
      return;
    }


    const selectItems: object[] = [];
    this.gridOptions.api.forEachNodeAfterFilterAndSort(function(node) {
        const shiphId: number = node.data['shiphId'];
        if (selectedShiphIdSet.has(shiphId)){
            const jsonUnit: object = {
              shiphId: shiphId
            };
            selectItems.push(jsonUnit);
        }
    });


    this.gridOptions.api.showLoadingOverlay();

    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shipInvoiceService
      .printByShip(this.printagentCd, '', selectItems, this.updprogramCd)
      .then(outputJson => {
        //印刷された場合のみファイル取得
        if(outputJson.printinvoiceNr > 0){
          //CreateForm帳票ファイル取得
          this.getFile(outputJson.reportCd, outputJson.jobId, outputJson.reporttrnId);
        }

        this.gridOptions.api.hideOverlay();
        sessionStorage.setItem('SuccessInfoMessage', '印刷が開始されました。');
        setTimeout(() => {
          this.working = false;
        }, 300);
      })
      .catch(error => {
        this.gridOptions.api.hideOverlay();
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  sendResult() {
    //現時点のフィルタを保持
    this.saveFilterState();
    this.router.navigate(['wa3015']);
  }

  oGridDetailButtonClick(node) {
    //現時点のフィルタを保持
    this.saveFilterState();
    this.isShowStockOutOverlay = true;
    sessionStorage.setItem('wa3011_stockout', JSON.stringify(node.data));
  }

  onTabChanged(index) {
    this.tabIndex = index;
    this.errorInfo = '';
    this.isTab1CheckboxChecked = false;
    this.isTab2CheckboxChecked = false;
    this.isEnableDropActions = false;
    this.selectedCount = 0;
    this.filterGrid();
    this.gridHelper.renderGridCheckboxImage();

    if (this.isForShipEndCheckBoxChecked) {
      this.isForShipEndCheckBoxChecked = false;
    }
    this.onSubmit();

    if (this.tabIndex !== 0) this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  filterGrid() {
    this.isEnableDropActions = false;
    const filterKeys = [];
    switch (this.tabIndex) {
      case 0:
        filterKeys.push('未引当');
        if (!this.isTab1CheckboxChecked) filterKeys.push('欠品');
        break;
      case 1:
        filterKeys.push('引当完了');
        if (!this.isTab2CheckboxChecked) filterKeys.push('キャンセル');
        break;
      default:
        if (this.isTab1CheckboxChecked) filterKeys.push('未引当');
    }
    //保持していたフィルタ
    const savedFilterModel = sessionStorage.getItem('wa3010_filterModel');
    // 保存されたフィルタモデルがあれば、それを適用
    if (savedFilterModel) {
    const filterModel = JSON.parse(savedFilterModel);
    this.gridOptions.api.setFilterModel(filterModel);
    //console.log('フィルタ状態を復元しました。', filterModel);
    }
    const bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);
    if (this.originalRowData == null || this.originalRowData.length == 0) return;

    const newRowDatas = [];
    this.originalRowData.forEach(data => {
      if (filterKeys.length == 0 || filterKeys.indexOf(data.stshipTx) != -1) {
        newRowDatas.push(data);
      }
    });

    this.gridOptions.api.updateRowData({
      add: newRowDatas
    });

    //this.rowData = newRowDatas;
    this.calTab1BadgeNumber(newRowDatas);
  }

  calTab1BadgeNumber(dataSource) {
    if (this.tabIndex == 0) {
      this.tab1BadgeNumber = 0;
      if (dataSource != null && dataSource.length > 0) {
        dataSource.forEach(data => {
          if (data.dterrorFl == 1 || data.deliassorterrorFl == 1) this.tab1BadgeNumber++;
        });
      }
    }
  }

  onSelectListClick() {
    if (!this.isEnableRightAreaButtons) return;

    if (!this.isEnableDropActions) return;

    this.isBlockActionMenu = true;
    this.isShowActionMenu = !this.isShowActionMenu;

    setTimeout(() => {
      this.isBlockActionMenu = false;
    }, 100);
  }

  onActionMenuBlur() {
    if (this.isBlockActionMenu) return;

    if (!this.isShowActionMenu) return;

    this.isShowActionMenu = false;
  }

  ngDoCheck() {
    this.isShowGridNoDataOverlay = this.gridHelper.isShowGridNoDataOverlay;
    if (this.gridOptions.api) {
      if (this.gridOptions.api.getSelectedNodes().length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    }

    if (sessionStorage.getItem('SuccessInfoMessage') == '出荷実績を送信しました。') {
      this.loading = true;
    } else {
      this.loading = false;
    }

    if (sessionStorage.getItem('wa3015ErrorMsg') != null) {
      this.errorInfo = sessionStorage.getItem('wa3015ErrorMsg');
      sessionStorage.removeItem('wa3015ErrorMsg');
    }
  }

  openoverlay() {
    this.errorInfo = '';
    this.overlay = Math.ceil(Math.random() * 100);
  }

  syukkaHikiate() {
    this.errorInfo = '';
    let ownerId: number;
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      // this.errorInfo = '対象を選択して下さい';
      return;
    };
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      if (i !== 0) {
        if (ownerId !== data['ownerId']) {
          this.errorInfo = '複数荷主の出荷指示を一度に引当することはできません。';
          return;
        }
      }
      ownerId = data['ownerId'];
    }
    this.overlaydspnone = false;
  }

  close1() {
    this.overlaydspnone = true;
  }

  close2() {
    this.overlaydspnone = true;
    setTimeout(() => {
      //データが残るための再取得
      this.onSubmit();
    }, 100);
  }

  /** Start stock-out overlay */
  closeStockOutOverlay() {
    this.isShowStockOutOverlay = false;
  }
  onShow3011Change(isClose3011AndRefreshGrid: boolean) {
    this.errorInfo = '';
    this.isShowStockOutOverlay = false;
    if (isClose3011AndRefreshGrid) this.onSubmit();
  }

  onShow3013Change(isClose3013AndRefreshGrid: boolean) {
    this.isShow3013 = false;
    if (isClose3013AndRefreshGrid) this.onSubmit();
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  inputChanged(ownerId: string) {
    if (ownerId == null) this.isOwnerSearchNone = true;
    else this.isOwnerSearchNone = false;
    this.changeOwner(ownerId);
  }

  ownerInputChanged(ownerId: string) {
    if (ownerId == null && ownerId !== undefined) this.gridHelper.isOwnerNotFound = true;
    else this.gridHelper.isOwnerNotFound = false;
    this.changeOwner(ownerId);
  }


  //CreateForm帳票ファイル取得呼び出し（クライアント印刷）
  getFile(reportCd, jobId, reporttrnId) {

    //クエリ文字列の生成
    cwebclient.FormRequestArray = getCreateFormRequest(JSON.parse(sessionStorage.getItem('loginResult'))['sessionKey'], jobId, reportCd, reporttrnId, '');
    //帳票印刷APIのURL
    cwebclient.CreatePrintingDataScriptUrl = this.createFormService.getReportUrl();
    // 帳票コードを引数に指定
    cwebclient.PrintExecuteEx(reportCd);

  }

  updateShipDate() {
    const selectedNodes: object[] = this.gridOptions.api.getSelectedNodes();
    const selectedShiphIdSet: Set<number> = new Set<number>();
    for (let i = 0; i < selectedNodes.length; i++) {
      const data = selectedNodes[i]['data'];
      if (data['stshipId'] == 47) {
        this.errorInfo = 'ステータス「出荷完了」が含まれていたため、出荷指示日を更新できませんでした。';
        return;
      }
      selectedShiphIdSet.add(data['shiphId']);
    }
    const selectItems: object[] = [];
    this.gridOptions.api.forEachNodeAfterFilterAndSort(function(node) {
        const shiphId: number = node.data['shiphId'];
        if (selectedShiphIdSet.has(shiphId)){
            const jsonUnit: object = {
              shiphId: shiphId
            };
            selectItems.push(jsonUnit);
        }
    });

    this.shipService
    .updateShipdate(this.shipDate, selectItems, 'wa3018')
    .then(outputJson => {
      sessionStorage.setItem('SuccessInfoMessage', '出荷指示日を更新しました。');
      this.working = false;
      this.onSubmit();
    })
    .catch(error => {
      this.working = false;
      console.log(this.commonService.getErrorMessage(error));
      this.errorInfo = this.commonService.getErrorMessage(error);
    });
  }

  initFixShipDateModal() {
    this.errorInfo = '';
    let today = new Date();
    this.shipDate = today.getFullYear() + '-' + this.pad(today.getMonth() + 1, 2) + '-' + this.pad(today.getDate(), 2);
    //現時点のフィルタを保持
    this.saveFilterState();
  }

  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }

  /**
  * フィルタ状態をセッションストレージに保存する
  */
  saveFilterState(): void {
    const filterModel = this.gridOptions.api.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
        //console.log('セッションにfilterセット------');
        sessionStorage.setItem('wa3010_filterModel', JSON.stringify(filterModel));
    } else {
        // フィルタが空の場合は保存されている値を削除
        sessionStorage.removeItem('wa3010_filterModel');
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3010/wa3010.component.ts